import React from 'react';
import I18n from 'i18n-js';
import bind from '../bind';

interface IState {
  sidebarOpen: boolean;
}

interface IProps {
  open?: boolean;
  close?: boolean;
}

export default class SidebarToggle extends React.Component<IProps, IState> {
  static defaultProps = {
    open: false,
    close: false,
  };

  state = {
    sidebarOpen: false,
  };

  @bind
  toggleSidebar() {
    this.setState({ sidebarOpen: !this.state.sidebarOpen }, () => {
      // This needs to be global state for mobile and to be preserved
      // when routing to a new nested route.
      document.body.classList.toggle('facet-sidebar-open');
      document.body.classList.toggle('mobile-panel-open');
    });
  }

  renderOpen() {
    return (
      /* disabling inline here so we can enable this rule globally, but this should be fixed the next time this file is touched */
      /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
      <a
        className="grid-filter__action"
        onClick={this.toggleSidebar}
        rel="nofollow"
      >
        {I18n.t('commons.filters.filterResults')}
      </a>
    );
  }

  renderClose() {
    return (
      /* disabling inline here so we can enable this rule globally, but this should be fixed the next time this file is touched */
      /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
      <a
        className="button size-90"
        onClick={this.toggleSidebar}
      >
        {I18n.t('commons.filters.closePanel')}
      </a>
    );
  }

  render() {
    if (this.props.open && this.props.close) {
      throw new Error('toggle can either be for opening or for closing, not both');
    }

    if (this.props.open) {
      return this.renderOpen();
    }

    if (this.props.close) {
      return this.renderClose();
    }
  }
}
